import { AxiosInstance } from '../../utilities/requestClient';
import { FailsPageModel } from './types';

export const getFails = async (
  startDate: string,
  endDate: string,
  fundId?: string,
): Promise<FailsPageModel> => {
  const url = `/fails_overview/${startDate}/${endDate}${fundId ? `/${fundId}` : ''}`;
  const response = await AxiosInstance.get<FailsPageModel>(url);
  return response.data;
};
